import { Component, OnInit } from '@angular/core';

type FusionViewWindow = Window & {
  fusionmeta?: unknown;
};

@Component({
  imports: [],
  templateUrl: './page-403.component.html',
  styleUrl: './page-403.component.scss'
})
export class Page403Component implements OnInit {

  public ngOnInit(): void {
    if (window.parent === window) return;

    try {
      const parentWindow = window.parent as FusionViewWindow;
      if (parentWindow.fusionmeta) {
        parentWindow.location.href = window.location.href;
      }
    } catch {
      // Cross-Origin-Parent: kein Zugriff auf fusionmeta, dann bleibt die 403-Seite im iframe.
    }
  }

}
